module.exports = __webpack_public_path__ + "flyer_background_bunting_008-cb6d7a8d9590d1cb40c1f73dbeeac456.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_bunting_008.jpg
// module id = 1612
// module chunks = 1